import workspaceQuery from '../../../graphql/queries/sales/ImportedEdiOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedEdiOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedEdiOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedXediOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedEdiOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedEdiOrderAggregateQuery.graphql';

import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedXediOrder: EntityType = {
  type: 'ImportedEdiOrder',
  title: 'Xedi Orders',
  formTitle: 'Imported Edi Order',
  workspaceUrl: '/Sales/Channel/ImportedXediOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedXediOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_XEDI_ORDERS',
  actions: [],
  operations: ALLOW_VIEW,
};

export default ImportedXediOrder;
